import { deriveManufacturedSize } from './derive.js';
export const drawingDeclaration = {
    version: 1,
    text: 'I confirm that I have checked all my selections and dimensions shown on the drawing and that they are correct. I understand that, if ordered, my door will be custom-made to these exact details.',
};
export function drawingApprovalBinding(door) {
    const state = { ...door };
    delete state.drawingApproval;
    return JSON.stringify({ door: state, manufacturedSize: deriveManufacturedSize(door.measurements) }, (_key, value) => typeof value === 'object' && value !== null && !Array.isArray(value)
        ? Object.fromEntries(Object.entries(value).sort(([first], [second]) => first < second ? -1 : first > second ? 1 : 0))
        : value);
}
export function createDrawingApproval(door, acceptedAt) {
    return {
        declarationVersion: drawingDeclaration.version,
        declarationText: drawingDeclaration.text,
        acceptedAt,
        binding: drawingApprovalBinding(door),
    };
}
export function isDrawingApprovalValid(door) {
    const approval = door.drawingApproval;
    return (approval !== undefined &&
        approval.declarationVersion === drawingDeclaration.version &&
        approval.declarationText === drawingDeclaration.text &&
        Number.isFinite(Date.parse(approval.acceptedAt)) &&
        approval.binding === drawingApprovalBinding(door));
}
//# sourceMappingURL=approval.js.map